import http from "../httpService";
import { apiUrl } from "../../../config.js";
import { DateTime } from "luxon";

const apiEndpoint = apiUrl + "/crm/crm-report/";

export function getCrmDashboard(fiscalYearID = 0, fiscalPeriodID = 0) {
  return http.get(
    apiEndpoint + "crm-dashboard/" + fiscalYearID + "/" + fiscalPeriodID
  );
}

export function getOpportunityValueSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "opportunity-value-summary/" + fiscalYearID);
}

export function getOpportunitySummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "opportunity-summary/" + fiscalYearID);
}

export function getTopSourcesSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-sources-summary/" + fiscalPeriodID);
}

export function getTopDealsSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-deals-summary/" + fiscalPeriodID);
}

export function getTopIndustryTypesSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-industry-types-summary/" + fiscalPeriodID);
}

export function getTopBusinessSizesSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-business-sizes-summary/" + fiscalPeriodID);
}

export function getTopCountriesSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-countries-summary/" + fiscalPeriodID);
}

export function getTopPrioritiesSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-priorities-summary/" + fiscalPeriodID);
}

export function getSalesPipelineStageSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "sales-pipeline-stage-summary/" + fiscalYearID);
}

export function getDealsStageSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "deals-stage-summary/" + fiscalYearID);
}

export function getSalesPipelineReport(
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day")
) {
  return http.get(apiEndpoint + `sales-pipeline-report/${dateFrom}/${dateTo}`);
}

export function getSalesmanPerformanceReport(
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day")
) {
  return http.get(
    apiEndpoint + `salesman-performance-report/${dateFrom}/${dateTo}`
  );
}

export function getSalesCardReport(
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day")
) {
  return http.get(apiEndpoint + `sales-card-report/${dateFrom}/${dateTo}`);
}

export function getVisitSchedulesReport(
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day")
) {
  return http.get(apiEndpoint + `visit-schedules/${dateFrom}/${dateTo}`);
}

export function getDirectSalesReport(
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day")
) {
  return http.get(apiEndpoint + `direct-sales/${dateFrom}/${dateTo}`);
}
